<ng-template #content>
  <ng-content></ng-content>
</ng-template>

@if (showBreadCrumbButton) {
  <button [matTooltip]="tooltip" class="btn-none" (click)="action.emit()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
} @else {
  <span>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </span>
}


<ng-content select="[suffix]"></ng-content>
